import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import GridAreaContainer from '@sprinx/react-mui-components/GridAreaContainer';
import ProductImageDecorated from '../ProductImageDecorated';
import ProductDetailLink from '../ProductDetailLink';
var cmpThemeCfg = {
  name: 'SxComProductListItemImage'
};
var useStyles = makeStyles({
  root: {},
  detailLink: {},
  image: {}
}, cmpThemeCfg);
var ProductListItemImage = /*#__PURE__*/React.forwardRef(function ProductListItemImage(_ref, ref) {
  var adornments = _ref.adornments,
      pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      ProductDetailLinkProps = _ref.ProductDetailLinkProps,
      ProductImageProps = _ref.ProductImageProps,
      renderToGridArea = _ref.renderToGridArea,
      shape = _ref.shape,
      shrink = _ref.shrink,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["adornments", "classes", "className", "product", "ProductDetailLinkProps", "ProductImageProps", "renderToGridArea", "shape", "shrink", "size"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement(GridAreaContainer, _extends({
    ref: ref,
    className: clsx(classes.root, className),
    renderToGridArea: renderToGridArea
  }, rest), /*#__PURE__*/React.createElement(ProductDetailLink, _extends({
    className: classes.detailLink
  }, ProductDetailLinkProps, {
    href: product.href
  }), /*#__PURE__*/React.createElement(ProductImageDecorated, _extends({
    className: classes.image
  }, ProductImageProps, adornments, {
    src: product.image,
    shape: shape,
    shrink: shrink,
    size: size,
    type: "image"
  }))));
});
ProductListItemImage.propTypes = {
  adornments: PropTypes.shape({
    adornmentAsideLeft: PropTypes.node,
    adornmentAsideRight: PropTypes.node,
    adornmentInsideBottomLeft: PropTypes.node,
    adornmentInsideBottomRight: PropTypes.node,
    adornmentInsideTopLeft: PropTypes.node,
    adornmentInsideTopRight: PropTypes.node
  }),
  classes: PropTypes.shape({
    detailLink: PropTypes.string,
    image: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  product: PropTypes.shape({
    href: PropTypes.string,
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))])
  }).isRequired,
  ProductDetailLinkProps: PropTypes.shape({}),
  ProductImageProps: PropTypes.shape({}),
  renderToGridArea: PropTypes.string,
  shape: PropTypes.oneOf(['square', 'landscape', 'portrait', 'wide', 'tall']),
  shrink: PropTypes.oneOf(['crop', 'fit']),
  size: PropTypes.oneOf(['mini', 'small', 'normal', 'big'])
};
ProductListItemImage.defaultProps = {
  adornments: undefined,
  classes: undefined,
  className: undefined,
  ProductDetailLinkProps: undefined,
  ProductImageProps: undefined,
  renderToGridArea: 'image',
  shape: undefined,
  shrink: undefined,
  size: undefined
};
export default withThemeProps(cmpThemeCfg)(ProductListItemImage);